import { render, staticRenderFns } from "./SendReminderModal.vue?vue&type=template&id=4389fd96&"
import script from "./SendReminderModal.vue?vue&type=script&lang=js&"
export * from "./SendReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports